/**
 * @file 创建的班级列表，包括协同给我的，我创建的
 * @author liudaoyu
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

 import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

/**
 * 我管理的班级
 */
export interface ICreatorClassInfo extends ISelectableClassInfo {
    stat: {
        joined_num: number;
        not_joined_num: number;
    };
}

export interface IInput {
    page: number; // int，必填，分页页码
    size: number; // int，必填，每页展示数据量
    keyword: string; // string，非必填，班级名称检索关键字
}

export const getCreateList = (data: IInput): Promise<IList<ICreatorClassInfo>> => {
    return fetchData(Api.CLASS_CREATE_LIST, data).then((res: IListResponse<ICreatorClassInfo>) => {
        return res.data as IList<ICreatorClassInfo>;
    });
};
